export default __webpack_public_path__ + "static/media/indogo-screenshot-01.6fb05909.png";